import createStore from "zustand";
import persist from "../utils/persist";

const useTimerStore = createStore(
  persist(
    {
      key: "timer",
      denylist: ["isLoading", "errorMessage"],
    },
    (set) => ({
      isLoading: false,
      errorMessage: "",
      timer: { h: 0, m: 0, s: 0, start: false, pause: true },
      setTimer: (data) => {
        set(() => ({
          timer: { ...data, start: false, pause: true },
        }));
      },

      setTimerStart: (data) => {
        set((state) => ({
          timer: { ...state.timer, pause: data.pause, start: data.start },
        }));
      },

      updateSeconds: (time) => {
        set((state) => ({
          timer: { ...state.timer, s: time },
        }));
      },

      updateMinutes: (time) => {
        set((state) => ({
          timer: { ...state.timer, m: time },
        }));
      },

      updateHours: (time) => {
        set((state) => ({
          timer: { ...state.timer, h: time },
        }));
      },

      updateMinutesSecond: (time) => {
        set((state) => ({
          timer: { ...state.timer, m: time.m, s: time.s },
        }));
      },

      updateHoursMinutesSecond: (time) => {
        set((state) => ({
          timer: { ...state.timer, h: time.h, m: time.m, s: time.s },
        }));
      },

      clearTimer: () => {
        set(() => ({
          timer: { start: false, pause: true, h: 0, m: 0, s: 0 },
        }));
      },
    })
  )
);

export default useTimerStore;
